(function(){  
  document.addEventListener('DOMContentLoaded', function() {
    let findAdditionalProductsEle;
    function AdditionalProductCustomization() {
      const AdditionalProductContainer = document.querySelectorAll('.tpo_option-set-wrapper');
      if(AdditionalProductContainer.length > 0){
        clearTimeout(findAdditionalProductsEle);
        // console.log('ele found');
        AdditionalProductContainer.forEach(ProductContainer=>{
          const Additional_product_images = ProductContainer?.querySelectorAll('.tpo_shape_square');
          if(Additional_product_images.length > 0){
            Additional_product_images.forEach((product_image, index) => {
              product_image.addEventListener('click', (event) => {
                updateMainPrice(event, index);
                update360View(event, index);
              });
            });          
          }
        });
      } else{
        // console.log('ele not found');
        findAdditionalProductsEle = setTimeout(AdditionalProductCustomization, 1000);
      }
      if(document.querySelector(".clickyboxes.options-select-movement") || document.querySelector(".clickyboxes.options-select-size")){
        var SelectVariant='';
        if(document.querySelector(".clickyboxes.options-select-movement")){
          SelectVariant = document.querySelector(".clickyboxes.options-select-movement")?.querySelectorAll("a");          
        }else{
          SelectVariant = document.querySelector(".clickyboxes.options-select-size")?.querySelectorAll("a");
        }
        // console.log(SelectVariant);
        if(SelectVariant.length > 0){
          SelectVariant.forEach(variant=>{ 
            const SelectVariantValue = variant?.getAttribute("data-handlevalue");
            const AdditionalProductPopup = document.querySelectorAll(`.${SelectVariantValue}-addtional-popup`);
            if(AdditionalProductPopup.length > 0){
              AdditionalProductPopup.forEach((productPopup, index)=> {
                productPopup.addEventListener('click', (event)=>{
                  openAdditionalPopup360Window(event, index);
                })
              });
            }
          })
        }
      }else{
        const AdditionalProductPopup = document.querySelectorAll(`.variant-default-title-addtional-popup`);
        if(AdditionalProductPopup.length > 0){
          AdditionalProductPopup.forEach((productPopup, index)=> {
            productPopup.addEventListener('click', (event)=>{
              openAdditionalPopup360Window(event, index);
            })
          });
        }
      }
    }
    findAdditionalProductsEle = setTimeout(AdditionalProductCustomization, 2000);
  });
})()
    
// Additional Product Price Addition
function updateMainPrice(event, index){
  const _this = event?.target?.closest('.tpo_shape_square');
  let variantPrice = 0;
  var has_checked = false;
  var wrapper = _this?.closest('.tpo_image-swatches-wrapper');
  var priceElement = wrapper?.querySelector('.tpo_image-swatches-tooltip')?.querySelector('.tpo_additional-price');
  if (priceElement) {
    variantPrice = parseFloat(priceElement.innerText.replace('SFr.', '').replace('CHF.', '').replace(',', '').replace(/[^\d.-]/g, '').trim());
  }
  if (_this.classList.contains('tpo_is_checked_swatches')) {
    has_checked = true;
  }
  var productPriceMainContainer = document.querySelector('.product-detail__form')?.querySelector('.price-area');
  var productPriceContainer = document.querySelector('.product-detail__form')?.querySelector('.current-price');
  var productPriceAdditionalPrice = parseFloat(document.querySelector('.product-detail__form')?.querySelector('.price-area')?.getAttribute('additional_price'));
  var productPriceElement = document.querySelector('.product-detail__form')?.querySelector('.current-price')?.getAttribute('total-price');
  var elementWrapper = document.querySelector('.product-detail__form')?.querySelector('.current-price')?.querySelector('.money');
  var productPrice = parseFloat(productPriceElement / 100);
  if(has_checked == true){
    productPrice += variantPrice;
    productPriceAdditionalPrice += variantPrice;
  } else{
    productPrice -= variantPrice;
    productPriceAdditionalPrice -= variantPrice;
  }
  // console.log(productPriceAdditionalPrice);
  productPriceMainContainer.setAttribute('additional_price', (productPriceAdditionalPrice));
  const Formatted_price = theme.Shopify.formatMoney((productPrice * 100), theme.money_format_with_code_preference);
  productPriceContainer.setAttribute('total-price', (productPrice * 100));
  elementWrapper.innerHTML = (Formatted_price);
}

// Update 360 Link with Additional Product on Product page
function update360View(event, index){
  // console.log(event.target);
  const _this = event?.target?.closest('.tpo_shape_square');
  var closest_section = _this?.closest('[data-section-id]');
  var sectionId = _this?.closest('[data-section-id]').dataset.sectionId;
  var gallery_container = closest_section?.querySelector('.theme-gallery');
  var swiperId = gallery_container?.querySelector('.swiper-container')?.getAttribute('data-swiper-id');
  var swiper = theme.swipers[swiperId];
  var underlineSelectedMedia = gallery_container?.getAttribute('data-underline-selected-media');
  var matchIndex = 0;
  var match;
  var swiperContainer = gallery_container?.querySelector('.swiper-container');
  var slides = swiperContainer.querySelectorAll('.swiper-slide:not([aria-hidden="true"]) .product-media');
  
  var has_checked = false;
  if (_this.classList.contains('tpo_is_checked_swatches')) {
    has_checked = true;
  }

  const closestWrapper = event?.target?.closest('.tpo_option-type-image-swatches-wrapper');
  
  
  const SelectedImages = closestWrapper?.querySelectorAll('.tpo_shape_square');
  var SelectedImagesLength = Array.from(SelectedImages).filter(images=> images?.classList.contains('tpo_is_checked_swatches'));
  var selected_item = '';
  var SelectVariantValue = '';
  var SelectVariant = '';
  if(document.querySelector(".clickyboxes.options-select-movement")){
    SelectVariant = document.querySelector(".clickyboxes.options-select-movement")?.querySelector("a.active");
  }else{
    SelectVariant = document.querySelector(".clickyboxes.options-select-size")?.querySelector("a.active");
  }
  if(SelectVariant){
    const SelectVariantDataValue = SelectVariant?.getAttribute("data-value");      
    SelectVariantValue = SelectVariant?.getAttribute("data-handlevalue");
    // selected_item = SelectVariantDataValue + ' + ' + SelectedImagesLength[(SelectedImagesLength.length - 1)]?.querySelector('input')?.value;
    selected_item = SelectVariantDataValue + ' + ' + event.target.closest('.tpo_is_checked_swatches')?.querySelector('input')?.value;
    if(event.target.closest('.tpo_is_checked_swatches')?.querySelector('input')?.value === undefined){
      selected_item = SelectVariantDataValue + ' + ' + SelectedImagesLength[(SelectedImagesLength.length - 1)]?.querySelector('input')?.value;      
    }
  }else{
    // selected_item = SelectedImagesLength[(SelectedImagesLength.length - 1)]?.querySelector('input')?.value;    
    selected_item = event.target.closest('.tpo_is_checked_swatches')?.querySelector('input')?.value; 
    if(selected_item === undefined){
      selected_item = SelectedImagesLength[(SelectedImagesLength.length - 1)]?.querySelector('input')?.value;      
    }
  }


  setTimeout(function () {      
        slides.forEach(function (slide, index) {
          const innerImageAlt = slide?.querySelector('img')?.getAttribute('alt');
          if(innerImageAlt.includes(',')){
            var splited_alt_tags = innerImageAlt.split(',');
            Array.from(splited_alt_tags).forEach(tag=>{
              tag = tag.trim();
              // console.log(selected_item + " = " + tag)
              if(selected_item == tag){
                matchIndex = index;
                match = slide;
              }
            });
          } else{
            // console.log(selected_item + "=" + innerImageAlt);
            if(selected_item == innerImageAlt){
              matchIndex = index;
              match = slide;
            }
          }
          // // console.log(selected_item + "=" + innerImageAlt);
          // if(selected_item == innerImageAlt){
          //   matchIndex = index;
          //   match = slide;
          // }
        });
    
        swiper.update();
        swiper.slideTo(matchIndex, theme.viewport.isXs() ? 500 : 800);
    
        if (underlineSelectedMedia) {
            var activeVariant = _this.querySelector('.product-media--active-variant');
            if (activeVariant) {
                activeVariant.classList.remove('product-media--active-variant');
            }
    
            if (match) {
                match.closest('.product-media').classList.add('product-media--active-variant');
            }
        }
    }, 300);
  
  if(has_checked == true){
    const additional_image = document.querySelectorAll(`.common-class-${index}`);
    if(additional_image.length > 0){
      additional_image.forEach(image=>{
        image.classList.add(`${SelectVariantValue}-addtional-popup-active`);
        image.removeAttribute('hidden');
      })
    }
    
    // if(document.querySelector('#popup-link') && SelectedImagesLength.length > 0) document.querySelector('#popup-link').setAttribute('hidden', '');
  }else{
    const additional_image = document.querySelectorAll(`.common-class-${index}`);
    if(additional_image.length > 0){
      additional_image.forEach(image=>{
        image.classList.remove(`${SelectVariantValue}-addtional-popup-active`);
        image.setAttribute('hidden', '');
      })
    }
    // if(document.querySelector('#popup-link').hasAttribute('hidden') && SelectedImagesLength.length == 0 && additional_image ){
    //   document.querySelector('#popup-link').removeAttribute('hidden', '');
    // }
  }
}
function openAdditionalPopup360Window(event, index){
  var SelectVariant = '';
  if(document.querySelector(".clickyboxes.options-select-movement")){
    SelectVariant = document.querySelector(".clickyboxes.options-select-movement")?.querySelector("a.active");    
  } else{
    SelectVariant = document.querySelector(".clickyboxes.options-select-size")?.querySelector("a.active");    
  }
  var SelectVariantValue = '';
  if(SelectVariant){
    SelectVariantValue = SelectVariant?.getAttribute("data-handlevalue");
  }else{
    SelectVariantValue = 'variant-default-title';
  }
  console.log(SelectVariantValue);
  const additional_url = document.querySelector(`.additional_product_url_metafields_${SelectVariantValue}_${index}`)?.value;
  if(additional_url && additional_url != '') create360ViewPopup(additional_url);
}
function create360ViewPopup(url){
  var view_close = document.querySelector('#view_close').getAttribute('value');
  var get_View_link = url;
  console.log(get_View_link);

  // Create the popup window container
  const popupWindowContainer = document.createElement('div');
  popupWindowContainer.id = 'popup-window';
  popupWindowContainer.style.position = 'fixed';
  popupWindowContainer.style.width = '100%';
  popupWindowContainer.style.height = '100%';
  popupWindowContainer.style.background = 'white';
  popupWindowContainer.style.border = '1px solid black';
  popupWindowContainer.style.padding = '10px';
  popupWindowContainer.style.margin = 'auto';
  popupWindowContainer.style.top = '0';
  popupWindowContainer.style.right = '0';
  popupWindowContainer.style.bottom = '0';
  popupWindowContainer.style.left = '0';
  popupWindowContainer.style.zIndex = '9999999999';
  popupWindowContainer.style.display = 'block'; // Change to 'none' to hide initially

  // Create the iframe element
  const iframe = document.createElement('iframe');
  iframe.setAttribute("id","popup_iframe")
  iframe.style.position = 'absolute';
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.right = '0px';
  iframe.style.bottom = '0px';
  iframe.src = `${get_View_link}`;
  const closeButton = document.createElement('a');
  closeButton.id = 'close-button';
  closeButton.style.position = 'absolute';
  closeButton.style.top = '0px';
  closeButton.style.right = '0px';
  closeButton.style.backgroundColor = 'black';
  closeButton.style.color = 'white';
  closeButton.innerHTML = `<img style="width: 35px;" src="${view_close}" alt="">`;
  closeButton.addEventListener('click', closePopup360Window);
  popupWindowContainer.appendChild(iframe);
  popupWindowContainer.appendChild(closeButton);
  document.body.appendChild(popupWindowContainer);

  document.body.classList.add('popup_open');
}
function closePopup360Window() {
  const popupWindowContainer = document.getElementById('popup-window');
  if (popupWindowContainer) {
      // Remove the popup window container from the DOM
      popupWindowContainer.remove();
  }
  document.body.classList.remove('popup_open');
}


// Add Additional Straps on cart.
const cartInner = document.querySelector('.cart_inner_main');
if(cartInner){
  const allStrapGrids = cartInner.querySelectorAll('.strap-item');
  if(allStrapGrids.length > 0){
    allStrapGrids.forEach(strap=> strap.addEventListener('click', addToCartStrap.bind(this)));
  }
}

async function addToCartStrap(evt){
  const _this = evt.target;
  // console.log(_this);
  const currentVarDetail = _this?.querySelector('.current_variant_detail');
  var currentVarId = '';
  if(currentVarDetail){
    currentVarId = currentVarDetail.getAttribute('data-strap_id');
  } 
  if(currentVarId && currentVarId != ''){
    // console.log(currentVarId);
    let updates = { id: Number(currentVarId), quantit: 1};
    const headers = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    const data = await response.json();
    console.log("data: ", data);
    window.location.reload();
  }
}

// Restrict User to checkout below min threshold....
window.restrictUserBySubmittingCheckout = function() {
  const checkoutButtons = document.querySelectorAll('input[type="submit"][name="checkout"]');
  if(checkoutButtons.length > 0){
    checkoutButtons.forEach(checkoutButton => {
      checkoutButton.addEventListener('click', function(event){
        ShowMessageBelowCheckoutButton(checkoutButton);
      });
    });
  }
}
function ShowMessageBelowCheckoutButton(checkoutButton){
  const min_threshold_value = window.theme.minCheckoutThreshold.min_threshold;
  const error_message = window.theme.minCheckoutThreshold.error_message;
  if(min_threshold_value == '' || min_threshold_value == null) return;
  const closestElement = checkoutButton.closest('div#cartform');
  if(!closestElement) return;
  const convertMinValuetoPriceString = theme.Shopify.formatMoney((min_threshold_value * 100), theme.money_format_with_code_preference);
  const convertMinValuetoPriceHtml = new DOMParser().parseFromString(convertMinValuetoPriceString, 'text/html');
  const MinThresholdValuePrice = convertMinValuetoPriceHtml?.querySelector('.money')?.innerText;
  
  if(error_message == '' || error_message == null) return;
  const updated_message = error_message.replace('[min_value]', MinThresholdValuePrice);
  
  const error_message_element = closestElement.querySelector('.cart_min_threshold_error_message');
  if(error_message_element){
    error_message_element.innerText = updated_message.replace('&#39;', "'");
    // setTimeout(()=>{
    //   error_message_element.innerText = '';
    // }, 5000)
  }
}

window.restrictUserBySubmittingCheckout();

